'use client';
var getLineClamp = function(lineClamp) {
    return {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: lineClamp,
        WebkitBoxOrient: "vertical"
    };
};

export { getLineClamp };
